import { Component, Input, Renderer, ElementRef } from '@angular/core';
import { PopoverEditableDropDownComponentBase } from '../../shared/components/popover-editable-dropdown.base.component';

//TODO: Remove from project
import { IIdNameGeneric } from '../../_entities';

@Component({
    selector: 'popover-editable-id-name-generic-dropdown',
    template: require('./popover-editable-dropdown.base.template.html')
})
export class PopoverEditableIdNameGenericDropdownComponent<T> extends PopoverEditableDropDownComponentBase<T> {
    constructor(protected renderer: Renderer, protected element: ElementRef) {
        super(renderer, element);
    }

    dropdownItems: IIdNameGeneric<T>[];

    @Input() tuples: Promise<IIdNameGeneric<T>[]>;

    protected getItems(): Promise<T[]> {

        return this.tuples.then(result => {
            this.dropdownItems = result;
            return this.dropdownItems.map(r => r.id);
        });

    }

    protected mapItem(items: T[], item: T): T {
        return items.find(x => x === item);
    }

    protected getDisplayValue(itemToFind: T) {

        if (itemToFind && this.dropdownItems) {
            const item = this.dropdownItems.find(x => x.id === itemToFind);
            if (item) {
                return item.name;
            }
        }

        if (itemToFind == null) {
            return null;
        }

   
        return itemToFind + "";
    }

    protected getValue(itemToFind: T): any {
        return itemToFind && this.dropdownItems ? this.dropdownItems.find(x => x.id === itemToFind) : null;
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable-id-name-generic-dropdown.component.ts